var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15377_30734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.75 4.5C11.0888 4.49924 10.4392 4.67445 9.8681 5.00764C9.29696 5.34084 8.82477 5.82002 8.5 6.396V4H7.5V8H11.5V7H9.30835C9.531 6.56558 9.86539 6.19833 10.2771 5.93606C10.6888 5.67379 11.163 5.52596 11.6508 5.5078C12.1386 5.48964 12.6225 5.6018 13.0526 5.83273C13.4826 6.06366 13.8434 6.40503 14.0978 6.8217C14.3521 7.23836 14.4908 7.71527 14.4996 8.20335C14.5084 8.69143 14.387 9.17304 14.1479 9.59862C13.9088 10.0242 13.5606 10.3784 13.1391 10.6247C12.7176 10.871 12.2382 11.0005 11.75 11H11.5V12H11.75C12.7446 12 13.6984 11.6049 14.4017 10.9017C15.1049 10.1984 15.5 9.24456 15.5 8.25C15.5 7.25544 15.1049 6.30161 14.4017 5.59835C13.6984 4.89509 12.7446 4.5 11.75 4.5Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3H2.5V4.5855L6.2071 8.29265L6.5 8.5855V13H8.5V12H9.5V13C9.5 13.2652 9.39464 13.5196 9.20711 13.7071C9.01957 13.8946 8.76522 14 8.5 14H6.5C6.23478 14 5.98043 13.8946 5.79289 13.7071C5.60536 13.5196 5.5 13.2652 5.5 13V9L1.7929 5.29265C1.70004 5.19979 1.62637 5.08954 1.57612 4.96821C1.52586 4.84687 1.5 4.71683 1.5 4.5855V3C1.5 2.73478 1.60536 2.48043 1.79289 2.29289C1.98043 2.10536 2.23478 2 2.5 2H13.5V3Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15377_30734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterResetIcon);
export default __webpack_public_path__ + "static/media/filterResetIcon.489aae967cb07214c8df15c175930024.svg";
export { ForwardRef as ReactComponent };